import { ValueOf } from 'shared/types/common';
import { SafelistTerm } from 'shared/types/safelist';

import { TermDictionary } from './TermReviewArea/types';

export const getDictionaryValues = (termDictionary: TermDictionary): ValueOf<TermDictionary>[] => (
  Object.values(termDictionary)
);

export const getTerms = (termDictionary: TermDictionary) => getDictionaryValues(termDictionary).forEach(
  ({ term }: ValueOf<TermDictionary>) => term
);

export const getSelectedTerms = (termDictionary: TermDictionary) => {
  const selectedTerms: SafelistTerm[] = [];

  getDictionaryValues(termDictionary).forEach(({ term, isSelected }: ValueOf<TermDictionary>) => {
    if (term.entity && isSelected) {
      selectedTerms.push(term);
    }
  });

  return selectedTerms;
};
